module.exports = __webpack_public_path__ + "img/tabIcMemberOn.cbe3b7fc.svg";